import axios from "axios";

let token = (localStorage.getItem('logged-in') && JSON.parse(localStorage.getItem('logged-in') || '')?.token) || ('')

const api = axios.create({
   baseURL: process.env.REACT_APP_API_KEY,
   timeout: 100000,
   transformRequest: [...axios.defaults.transformRequest],
   transformResponse: [...axios.defaults.transformResponse],
   headers: { ...axios.defaults.headers }

});

if (token) {
   api.defaults.headers.common["Authorization"] = `Bearer ${token}`
}


api.interceptors.request.use(function (config) {
   return config;
}, function (error) {
   return Promise.reject(error);
});


api.interceptors.response.use(function (response) {
   return response;
}, function (error) {
   if (error?.response?.status === 401) {
      window.location.href = "/auth/login";
      localStorage.removeItem('logged-in')
   }
   return Promise.reject(error);
});

export default api;